import React from 'react';
import MaterialTable from 'material-table'
import {
  Card, CardContent, CardActions, TextField, Box,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import CardTitle from '../../../components/sharedComponents/CardTitle';
import Button from '../../../components/sharedComponents/CustomButtons/Button';
import { useStyles } from './styles';

const ChannelsPage = (props) => {
  const {
    open,
    channels,
    openForm,
    onSubmitForm,
    onChangeInput,
    onUpdateChannel,
    onDeleteChannel,
  } = props;
  const classes = useStyles();
  const columns = [
    { title: 'CANAL', field: 'canal' },
    { title: 'ID', field: 'id', hidden: true },
  ];
  return (
    <>
      <CardTitle title="Gestión de Canales" />

      <Card className={classes.card}>
        {open ? (
          <Box component="form" onSubmit={onSubmitForm}>
            <CardContent>
              <TextField
                onChange={(e) => onChangeInput(e.target.value, 'channel')}
                required
                label="Canal"
                variant="outlined"
                fullWidth
              />
            </CardContent>
            <CardActions>
              <Button onClick={openForm} color="warning">Cancelar</Button>
              <Button color="warning" type="submit">Crear</Button>
            </CardActions>
          </Box>
        ) : (
          <Button fullWidth onClick={openForm} color="warning">
            Crear Canal
          </Button>
        )}
      </Card>

      <MaterialTable
        style={{ color: 'ff9800' }}
        title="Canales"
        columns={columns}
        data={channels}
        editable={{
          onRowUpdate: (newData) => new Promise((resolve) => {
            onUpdateChannel({
              newData,
            });
            setTimeout(() => {
              resolve();
            }, 2000);
          }),
        }}
        options={{
          headerStyle: {
            backgroundColor: '#FAA500',
            color: '#FFF',
          },
          actionsColumnIndex: -1,
        }}
        actions={[
          {
            icon: () => <Delete />,
            tooltip: 'Eliminar',
            onClick: (event, rowData) => onDeleteChannel(rowData),
          },
        ]}
      />
    </>
  );
};

export default ChannelsPage;
